import { animate, style, transition, trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AlertService } from '@shared/components/alert/alert.service';

@Component({
  selector: 'app-alert',
  imports: [NgIf],
  templateUrl: './alert.component.html',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(60px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AlertComponent {
  alertService = inject(AlertService);
}
